import { render, staticRenderFns } from "./order_purchase_detail.vue?vue&type=template&id=5673b07b&scoped=true&"
import script from "./order_purchase_detail.vue?vue&type=script&lang=js&"
export * from "./order_purchase_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_purchase_detail.vue?vue&type=style&index=0&id=5673b07b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5673b07b",
  null
  
)

export default component.exports